<template>
  <div>
    <div>
      <warning-msg
        v-for="(interaction, index) in interactions"
        v-bind:key="index"
        :message="interaction"
        style="margin-top: 2px"
        :deletable="true"
        @closeEvent="closeWarning(index)"
      />
    </div>
    <div id="div_new_activity_domestic">
      <div class="element-input" style="margin-right: 20px">
        <v-date-picker mode="multiple" :locale="locale" v-model="dates" :min-date="minDate" @input="checkDates()" :max-date="maxdate" />
      </div>
      <div class="element-input">
        <timepicker v-model="startTime" class="input_time" :value="0" @input="checkDates()" :placeholder="'Orario'" />
      </div>
      <div class="element-input">
        <input class="input_integer" v-model.number="duration" @change="checkDates" type="number" />
      </div>
      <div class="element-input">
        <v-select2
          :value="filters['userSelect']"
          :element_id.sync="filters['userSelect']"
          :multiple="true"
          :data-placeholder="i18nJS.user_label"
          data-ajax--url="/it/users?type=presents"
          data-minimumInputLength="0"
          @input="disableForm"
          data-pageLimit="20"
          :data-allow-clear="false"
          id="select2-user"
        />
      </div>
      <div class="element-input">
        <v-select2
          :value="filters['activitySelect']"
          :element_id.sync="filters['activitySelect']"
          :multiple="true"
          :data-placeholder="i18nJS.activities"
          :data-ajax--url="'/it/activities_configs?business_unit_id=' + buId + '&guest_siad_filter=true&type=activity'"
          data-minimumInputLength="0"
          data-pageLimit="20"
          @input="disableForm"
          :data-allow-clear="false"
          id="select2-activity-domestic"
        />
      </div>
      <div class="element-input">
        <v-select2
          :value="filters['profiloSelect']"
          :element_id.sync="filters['profiloSelect']"
          :data-placeholder="'Percorso'"
          :options-list="[
            ['CD BASE PRELIEVO', 10],
            ['CD BASE PRESTAZIONALE GENERICO', 11],
            ['CD BASE PERCORSO GESTIONE ALVO', 12],
            ['CD BASE PERCORSO GESTIONE CATETERE', 13],
            ['CD BASE PERCORSO GESTIONE STOMIE', 14],
            ['CD INTEGRATE PERCORSO LESIONI A', 15],
            ['CD INTEGRATE PERCORSO LESIONI B', 16],
            ['CD INTEGRATE PERCORSO LESIONI C', 17],
          ]"
          data-minimumInputLength="0"
          data-pageLimit="20"
          @input="disableForm"
          :data-allow-clear="false"
          id="select2-profilo-domestic"
        />
      </div>
      <div class="element-input">
        <button id="save-activity" :disabled="disableForm()" type="button" class="btn btn-link no_border" @click="addActivity()">
          <i id="plus-icon" class="far fa-plus pulsante_comando" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect2 from '../vSelect2';
import timepicker from '../timepicker';
import apiConnector from '@/epersonam/apiConnector';
import warningMsg from '../warningMsg';
import { Route } from '../../route';

const formEmptyFilters = () => ({
  userSelect: [],
  activitySelect: [],
  profiloSelect: null,
});

export default {
  name: 'insertActivityDomestic',
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    locale() {
      return window.locale;
    },
  },
  components: {
    timepicker,
    vSelect2,
    warningMsg,
  },
  props: ['buId', 'dateStartPeriod', 'dateEndPeriod', 'timeStartPeriod', 'timeEndPeriod', 'guestPeriodDataSetId', 'fluxActivityId'],
  methods: {
    create_data_activity(dates) {
      for (let date of dates) {
        for (let activity of this.filters.activitySelect) {
          this.guest_activity_domestics.push({
            user_id: this.filters.userSelect[0], // first user select
            start: date.start,
            end: date.end,
            activities_config_id: activity,
            activity_id: this.fluxActivityId,
            duration: this.duration,
            profilo: this.filters.profiloSelect,
            guest_activity_domestic_users_attributes: this.filters.userSelect
              .filter((el) => {
                return el != '';
              })
              .map((user) => {
                return { user_id: user };
              }),
          });
        }
      }
      return this.guest_activity_domestics;
    },
    setStarEndDates(calendarDates, time, duration) {
      let listDates = calendarDates.map((newVal) => {
        return {
          start: this.formatDateString(newVal, time),
          end: this.formatDateString(newVal, time, duration),
        };
      });
      return listDates;
    },
    formatDateString(newVal, time, duration = 0) {
      let t = time.split(':');
      return moment(newVal).set('hour', t[0]).set('minute', t[1]).add(duration, 'm').toISOString();
    },
    addActivity() {
      this.disableClickSave = true;
      Loader.show();
      let dates = this.setStarEndDates(this.dates, this.startTime, this.duration);
      apiConnector()
        .post(`${Route.DOMESTIC}/create_flux_activity_registration.json`, {
          guest_activity_domestic: this.create_data_activity(dates),
          gpds_id: this.guestPeriodDataSetId,
        })
        .then((response) => {
          if (response.data.status != 'created') {
            this.interactions.push(i18nJS.errors.range_date_error);
          }
          this.$emit('update', response.data);
        })
        .catch(() => {
          this.interactions.push(`Inseriemnto non riuscito`);
        })
        .finally(() => {
          Loader.hide();
          this.disableClickSave = false;
          this.guest_activity_domestics = [];
        });
    },
    disableForm() {
      // active form only in this case: false = false OR !true
      let validateForm =
        this.dates.length &&
        this.filters['userSelect'] != undefined &&
        this.filters['userSelect'].length &&
        this.filters['userSelect'] != '' &&
        this.filters['activitySelect'] != undefined &&
        this.filters['activitySelect'].length &&
        this.filters['activitySelect'] != '';
      return this.disableClickSave || !validateForm;
    },
    checkDates() {
      this.disableClickSave = false;
      if (this.dates.length) {
        const minDate = moment(this.dateStartPeriod + ' ' + this.timeStartPeriod, 'YYYY-MM-DD HH:mm:ss');
        const maxdate = moment(this.dateEndPeriod + ' ' + this.timeEndPeriod, 'YYYY-MM-DD HH:mm:ss');
        for (let date of this.dates) {
          const dateNew = moment(date.toLocaleDateString() + ' ' + this.startTime, i18nJS.time.formats.aux);
          if (!dateNew.isBetween(minDate, maxdate, 'minutes', '[]')) {
            this.interactions.push(
              `La data e ora ${dateNew.format('DD/MM/YYYY HH:mm')} non è compresa nell'intervallo del siad ${minDate.format('DD/MM/YYYY HH:mm')} - ${maxdate.format('DD/MM/YYYY HH:mm')}`,
            );
            this.disableClickSave = true;
          }
        }
      }
      this.disableForm();
    },
    closeWarning(index) {
      this.interactions.splice(index, 1);
    },
  },
  data() {
    return {
      itemSelected: null,
      startTime: '08:00',
      duration: 0,
      minDate: new Date(moment(this.dateStartPeriod).add(-1, 'mounths').format()),
      maxdate: new Date(moment(this.dateEndPeriod).add(-1, 'mounths').format()),
      disableClickSave: true,
      filters: formEmptyFilters(),
      guest_activity_domestics: [],
      dates: [],
      interactions: [],
    };
  },
};
</script>

<style lang="scss" scoped>
#div_new_activity_domestic {
  margin-top: 20px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}

.pulsante_comando {
  font-size: 15px;
  margin: 0px 3px;
  vertical-align: middle;
  border: solid 1px;
  border-radius: 100%;
  padding: 11px;
}

.pulsante_comando.fa-plus {
  padding: 6px 8px;
}

#new-activity-domestic {
  margin-top: 20px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}

.element-input {
  margin-left: 20px;
}

.graycolor {
  color: #999;
}

.input_date {
  margin-bottom: 0px;
}
input[type='number'] {
  width: 50px;
}
#select2-activity-domestic {
  max-width: 500px;
  min-width: 300px;
}
#select2-user {
  max-width: 500px;
  min-width: 250px;
}
</style>
